import { render } from "./PriceComparison.vue?vue&type=template&id=1f0b1bf5"
import script from "./PriceComparison.vue?vue&type=script&lang=js"
export * from "./PriceComparison.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/BuyersGuide/PriceComparison.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f0b1bf5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f0b1bf5', __exports__)) {
    api.reload('1f0b1bf5', __exports__)
  }
  
  module.hot.accept("./PriceComparison.vue?vue&type=template&id=1f0b1bf5", () => {
    api.rerender('1f0b1bf5', render)
  })

}


export default __exports__